import {endpoints} from './endpoints'
import request from '../request'

export function getDashboardInfo(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getDashboardInfo,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getDashboard(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getDashboard,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getDashboardWeekly(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getDashboardWeekly,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getDashboardWeeklyExport(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getDashboardWeeklyExport,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getDashboardRDI(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getDashboardRDI,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getDashboardRDIWeekly(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getDashboardRDIWeekly,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getDashboardRDIWeeklyExport(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getDashboardRDIWeeklyExport,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}
